import React from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import RedeemIcon from "@mui/icons-material/Redeem";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

const Reservationheader = () => {
  return (
    <div className="header-wrapper">
      <div className="header-container">
        {/* Left Side - Contact Info */}
        <div className="contact-section">
          <div className="contact-item">
            <PhoneIcon className="contact-icon" />
            <span>Phone : </span>
            <a href="tel:+13364682300">336-468-2300</a>
          </div>
          <div className="divider">|</div>
          <div className="contact-item">
            <EmailIcon className="contact-icon" />
            <a href="mailto:littleheavenlodge@gmail.com">littleheavenlodge@gmail.com</a>
          </div>
        </div>

        {/* Right Side - Action Cards */}
        <div className="actions-section">
          <a
            href="https://secure.thinkreservations.com/littleheavenbedandbreakfast/gift-certificates"
            className="action-card gift-card"
          >
            <div className="card-content">
              <RedeemIcon className="card-icon" />
              <span className="card-text">Gift Certificates</span>
            </div>
            <div className="card-glow"></div>
          </a>

          <div className="separator">|</div>

          <a
            href="https://secure.thinkreservations.com/littleheavenbedandbreakfast/reservations"
            className="action-card reservation-card"
          >
            <div className="card-content">
              <CalendarMonthIcon className="card-icon" />
              <span className="card-text">Reservations</span>
            </div>
            <div className="card-glow"></div>
          </a>
        </div>
      </div>

      <style jsx>{`
        .header-wrapper {
          background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
          color: white;
          position: relative;
          z-index: 5;
          box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1);
          margin-bottom: 2px;
        }

        .header-container {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 24px;
          min-height: 44px;
        }

        /* Contact Section */
        .contact-section {
          display: flex;
          align-items: center;
          gap: 16px;
          flex: 1;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 13px;
          font-weight: 500;
        }

        .contact-icon {
          font-size: 16px !important;
          opacity: 0.9;
          color: #3498db;
        }

        .contact-item a {
          color: white;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .contact-item a:hover {
          color: #3498db;
          text-shadow: 0 0 6px rgba(52, 152, 219, 0.4);
        }

        .divider {
          color: rgba(255, 255, 255, 0.6);
          margin: 0 8px;
          font-weight: 300;
        }

        /* Actions Section */
        .actions-section {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .action-card {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 6px 16px;
          background: rgba(255, 255, 255, 0.15);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 20px;
          text-decoration: none;
          color: white;
          font-weight: 600;
          font-size: 13px;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          overflow: hidden;
          backdrop-filter: blur(10px);
        }

        .card-content {
          display: flex;
          align-items: center;
          gap: 8px;
          z-index: 2;
          position: relative;
        }

        .card-icon {
          font-size: 18px !important;
          transition: all 0.4s ease;
        }

        .card-glow {
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, transparent 70%);
          opacity: 0;
          transition: all 0.4s ease;
          z-index: 1;
        }

        .gift-card:hover {
          transform: translateY(-2px) scale(1.05);
          background: linear-gradient(135deg, #ff6b6b, #ff8e53);
          border-color: rgba(255, 107, 107, 0.5);
          box-shadow: 0 8px 25px rgba(255, 107, 107, 0.4);
        }

        .reservation-card:hover {
          transform: translateY(-2px) scale(1.05);
          background: linear-gradient(135deg, #4ecdc4, #44a08d);
          border-color: rgba(78, 205, 196, 0.5);
          box-shadow: 0 8px 25px rgba(78, 205, 196, 0.4);
        }

        .action-card:hover .card-glow {
          opacity: 1;
          animation: pulse 2s infinite;
        }

        .action-card:hover .card-icon {
          transform: scale(1.15) rotate(5deg);
        }

        .separator {
          color: rgba(255, 255, 255, 0.4);
          font-size: 16px;
          margin: 0 4px;
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 0.6; transform: scale(1.1); }
        }

        /* Mobile Responsive */
        @media (max-width: 768px) {
          .header-container {
            flex-direction: column;
            gap: 8px;
            padding: 12px 20px;
            min-height: auto;
          }

          .contact-section {
            justify-content: center;
            flex-wrap: wrap;
            gap: 8px;
          }

          .divider {
            display: none;
          }

          .actions-section {
            justify-content: center;
            gap: 12px;
          }

          .action-card {
            padding: 6px 14px;
            font-size: 12px;
          }

          .card-icon {
            font-size: 16px !important;
          }
        }

        @media (max-width: 480px) {
          .header-container {
            padding: 10px 16px;
          }

          .contact-item {
            font-size: 12px;
            gap: 3px;
          }

          .contact-icon {
            font-size: 14px !important;
          }

          .actions-section {
            gap: 10px;
            flex-wrap: wrap;
          }

          .action-card {
            padding: 5px 10px;
            font-size: 11px;
            min-width: 100px;
          }

          .separator {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default Reservationheader;